export default __webpack_public_path__ + "static/media/oasis-clouds.06e02ca6.png";